export default __webpack_public_path__ + "static/media/dollhouse.a2f4beff.svg";